__turbopack_context__.v({
  "error": "_qo5xa_error",
  "list": "_qo5xa_list",
  "paginationButton": "_qo5xa_paginationButton",
  "paginationButtonContainer": "_qo5xa_paginationButtonContainer",
});
